import { v4 as uuidv4 } from 'uuid';

export * from './array';
export * from './layout';
export * from './maps.utils';
export * from './validate.utils';

export const GenerateId = () => {
    return uuidv4();
}
